import { render, staticRenderFns } from "./TaskListItemDetail.vue?vue&type=template&id=8e7d1440&scoped=true&"
import script from "./TaskListItemDetail.vue?vue&type=script&lang=ts&"
export * from "./TaskListItemDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TaskListItemDetail.vue?vue&type=style&index=0&id=8e7d1440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7d1440",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
